module.exports = __webpack_public_path__ + "media/images/homepage/Footer_OR_Logo_Black-c023147ffd717cca496219741e95b9be.png";